import { StructuredText } from "react-datocms/structured-text";
import './RenderStoryCard.css';


export const RenderStoryCard = ({ data: { data: { storyCard } } }: { data: any }) => {
  const dummyImageUrl = "https://via.placeholder.com/150";
  const { backgroundImage, image, textAfterImage, textBeforeImage } = storyCard;

  // Assume backgroundImage is always provided. If not, adjust logic accordingly.
  const backgroundImgUrl = backgroundImage ? backgroundImage.url : dummyImageUrl;
  const cardImgUrl = image ? image.url : null;

  return (
    <div className="storyCardContent" style={{ backgroundImage: `url(${backgroundImgUrl})` }}>
      {/* Render textBeforeImage */}
      {textBeforeImage && textBeforeImage.value ? (
        <StructuredText data={textBeforeImage.value} />
      ) : null}

      {/* Placeholder for image - replace with actual rendering logic if needed */}
      {cardImgUrl && (<img src={cardImgUrl} />)}

      {/* Render textAfterImage */}
      {textAfterImage && textAfterImage.value ? (
        <StructuredText data={textAfterImage.value} />
      ) : null}
    </div>
  );
};